import { CloseOutlined } from '@ant-design/icons';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useKeymap from '@/hooks/pure/useKeymap';
import UploadStyles from '@/layouts/UploadLayout';

import FeedbackCsvUploadBody from './FeedbackCsvUploadBody';

const FeedbackCsvUpload = () => {
  const wr = useWorkspaceRouter();
  const closeModal = () => {
    wr.push('/feedbacks');
  };
  const color = useColor();

  useKeymap('Escape', closeModal);

  return (
    <UploadStyles.UploadLayout>
      <UploadStyles.HeaderArea>
        <Flex
          a="center"
          style={{ padding: '0 32px', height: '100%' }}
          j="space-between"
        >
          <Typo type="body2" weight="sb" color={color.gray800}>
            Upload CSV / Excel
          </Typo>
          <IconButton
            icon={<CloseOutlined />}
            onClick={closeModal}
            tooltip="Close"
            shortcut="ESC"
          />
        </Flex>
      </UploadStyles.HeaderArea>
      <UploadStyles.BodyArea>
        <FeedbackCsvUploadBody closeUploadModal={closeModal} />
      </UploadStyles.BodyArea>
    </UploadStyles.UploadLayout>
  );
};

export default FeedbackCsvUpload;
